import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Undo2, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Prullenbak: verwijderde motoren terugzetten.
export const TrashDialog = ({ open, onClose, onRestored }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    if (!open) return;
    setItems(null);
    axios.get(`${API}/admin/motorcycles-trash`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [open]);

  const restore = async (it) => {
    setBusy(it.id);
    try {
      await axios.post(`${API}/admin/motorcycles-trash/${it.id}/restore`);
      toast.success(`${it.brand} ${it.model} is teruggezet`);
      setItems((xs) => xs.filter((x) => x.id !== it.id));
      onRestored();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Terugzetten mislukt');
    } finally {
      setBusy(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="trash-dialog">
        <DialogHeader>
          <DialogTitle>Prullenbak</DialogTitle>
          <DialogDescription>Verwijderde motoren. Met Terugzetten staat de motor weer in je voorraad, precies zoals hij was.</DialogDescription>
        </DialogHeader>
        {!items && <div className="flex justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-zinc-400" /></div>}
        {items?.length === 0 && <p className="text-sm text-zinc-500 py-4" data-testid="trash-empty">De prullenbak is leeg.</p>}
        <div className="max-h-[60vh] overflow-y-auto divide-y divide-zinc-100">
          {items?.map((it) => (
            <div key={it.id} className="flex items-center gap-3 py-2.5" data-testid={`trash-item-${it.id}`}>
              <div className="w-14 h-14 rounded bg-zinc-100 overflow-hidden shrink-0">
                {it.images?.[0] && <img src={it.images[0]} alt="" className="w-full h-full object-cover" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold truncate">{it.brand} {it.model} {it.year ? `(${it.year})` : ''}</div>
                <div className="text-[11px] text-zinc-500">
                  {new Date(it.deleted_at).toLocaleString('nl-NL')} · {it.reason}{it.deleted_by ? ` · ${it.deleted_by}` : ''}
                </div>
              </div>
              <button onClick={() => restore(it)} disabled={busy === it.id} data-testid={`trash-restore-${it.id}`}
                      className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white disabled:opacity-50">
                {busy === it.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Undo2 className="w-3.5 h-3.5" />}Terugzetten
              </button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
